<script>
    import Mute from './Mute.svelte';
    import Button from './Button.svelte';

    export let state;
    const style = "flex: 0 0 auto";
</script>


<div>
    <!-- <Button message={{state: [['health', '+', -1]]}}>-1 health</Button> -->
    <Button message={{dest: state.pageIndex === 'glossary' ? 'back' : 'glossary'}} {style}>{state.pageIndex === 'glossary' ? 'Back' : 'Glossary'}</Button>
    <Button message={{dest: state.pageIndex === 'credits' ? 'back' : 'credits'}} {style}>{state.pageIndex === 'credits' ? 'Back' : 'Credits'}</Button>
    <Button href="https://uic.ca1.qualtrics.com/jfe/form/SV_7WWYancFaBkQFQG" {style}>Survey</Button>
    {#if (state.pageIndex !== 'home' && state.pageIndex !== 'credits') || (state.pageIndex === 'credits' && state.back[0] !== 'home')}
        <Button message={{dest: state.pageIndex === "choose your character" ? "home" : "start over?"}} {style}>{state.pageIndex === "choose your character" ? "Back" : "Start Over"}</Button>
    {/if}
    <Button tooltip={`${state.soundEnabled ? 'Disable' : "Enable"} sound`} message={{state: [['soundEnabled', '!']]}} {style}><Mute soundEnabled={state.soundEnabled}/></Button>
</div>



<style lang="less">
    @import "./common.less";
    div {
        flex: 0 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: flex-end; /* along flex-direction */
        align-items: center; /* perpendicular to flex-direction */
        flex-wrap: wrap;
    }
    .desktop({
        div {
            gap: 6px;
        }
    });
</style>